import { string } from 'yup-v1-latest';

/**
 * Creates a yup string schema with validation for positive numeric values.
 * This is commonly used for fields like unitNotionalAmount and unitLoanAmount.
 *
 * @param fieldName - The name of the field for error messages (e.g., 'Unit notional amount', 'Unit loan amount')
 * @returns A yup string schema with numeric and positive validations
 */
export function positiveNumericString(fieldName: string) {
  return string()
    .required(`${fieldName} is required`)
    .test('is-numeric', `${fieldName} must be a valid number`, value => {
      if (!value) {
        return true; // let .required() handle emptiness
      }
      const num = Number(value);
      return !isNaN(num) && isFinite(num);
    })
    .test('is-positive', `${fieldName} must be greater than 0`, value => {
      if (!value) {
        return true; // let .required() handle emptiness
      }
      return Number(value) > 0;
    });
}
